var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kanban"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":require("./img/q1.png"),"alt":""}})])}]

export { render, staticRenderFns }